import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import Link from 'next/link';
import { Typography } from "@vc-workspace/utils-typography";
export function Breadcrumbs(props) {
  if (!props.breadcrumbList.length) {
    return null;
  }

  return _jsxs("div", {
    children: [_jsx(Link, {
      href: "/",
      passHref: true,
      children: _jsx(Typography, {
        type: "Body1",
        color: "silver_chalice",
        hover_color: "nero",
        inline: true,
        children: "Home"
      })
    }), _jsx(Typography, {
      type: "Body1",
      color: "silver_chalice",
      className: "px-1",
      inline: true,
      children: "/"
    }), props.breadcrumbList.map(function (item) {
      return _jsx(_Fragment, {
        children: item.url ? _jsx(Link, {
          href: item.url,
          passHref: true,
          children: _jsxs("span", {
            children: [_jsx(Typography, {
              type: "Body1",
              color: "silver_chalice",
              hover_color: "nero",
              inline: true,
              children: item.label
            }), _jsx(Typography, {
              type: "Body1",
              color: "silver_chalice",
              className: "px-1",
              inline: true,
              children: "/"
            })]
          })
        }) : _jsx(_Fragment, {
          children: _jsx(Typography, {
            type: "Body1",
            color: "silver_chalice",
            inline: true,
            bold: true,
            children: item.label
          })
        })
      });
    })]
  });
}
export default Breadcrumbs;